import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import { useSelector } from "react-redux";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import dayjs from "dayjs";
import { Button } from "antd";
import SupportReplyDialog from "../DialogBoxes/SupportReplyDialog";

const SupportAction = () => {
  const navigate = useNavigate();
  const { ticketId } = useParams();
  const [formData, setFormData] = useState({
    customerName: "",
    userName: "",
    email: "",
    helpText: "",
    createdOn: "",
    communications: []
  });
  const [openReplyDialog, setOpenReplyDialog] = useState(false);

  const handleReplyClick = () => {
    setOpenReplyDialog(true);
  };

  const handleReplySuccess = () => {
    setOpenReplyDialog(false);
  };

  const fetchData = async (ticketId) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.TICKET_DETAILS(ticketId)
      });

      if (response.success) {
        setFormData({
          customerName: response.data.customer_name,
          userName: response.data.user_name,
          email: response.data.email_id,
          status: response.data.status,
          helpText: response.data.communication?.[0]?.message || "",
          createdOn: dayjs(response.data.email_id.createdAt).format(
            "DD/MM/YYYY"
          ),
          communications: response.data.communication || []
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (ticketId) {
      fetchData(ticketId);
    }
  }, [ticketId]);

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold">
        <BackIcon onClick={() => navigate(-1)} className="cursor-pointer" />
        <div> {ticketId}</div>
      </div>

      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          padding: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F"
        }}
      >
        <form className="space-y-4 my-20">
          <div className="flex justify-between mx-20 mb-16">
            <div>
              <label className="block font-semibold text-gray-500">
                Customer Name
              </label>
              <input
                type="text"
                name="customerName"
                value={formData.customerName}
                disabled
                className=" p-2 border-b bg-gray-100 cursor-not-allowed"
              />
              <label className="block font-semibold text-gray-500 mt-8">
                User Name
              </label>
              <input
                type="text"
                name="userName"
                value={formData.userName}
                disabled
                className=" p-2 border-b bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block font-semibold text-gray-500 ">
                Ticket ID
              </label>
              <input
                type="text"
                name="contactNumber"
                value={ticketId}
                disabled
                className=" p-2 border-b bg-gray-100 cursor-not-allowed"
              />
              <label className="block font-semibold text-gray-500 mt-8">
                Status
              </label>
              <input
                type="text"
                name="status"
                value={formData.status}
                disabled
                className=" p-2 border-b bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block font-semibold text-gray-500">
                Created Date
              </label>
              <input
                type="text"
                name="contactNumber"
                value={formData.createdOn}
                disabled
                className=" p-2 border-b bg-gray-100 cursor-not-allowed"
              />
            </div>
          </div>

          <div style={{ background: "#06513D2E" }} className="py-4">
            <div className="text-center">
              <div className="space-y-4 max-h-[400px] overflow-y-auto px-6">
                {formData.communications.map((comm, index) => (
                  <div
                    key={index}
                    className="bg-gray-100 text-left rounded-none p-4 shadow-sm"
                  >
                    <div className="text-sm font-semibold">
                      {comm.userType === "support" ? "Support" : "Customer"}:
                    </div>
                    <div className="flex justify-between items-end">
                      <div className="text-sm mt-1">{comm.message}</div>
                      <div className="text-xs text-gray-500 mt-1">
                        {dayjs(comm.createdAt).format("DD/MM/YYYY hh:mm A")}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="text-center my-5">
              <Button
                type="primary"
                style={{ background: "#06513D" }}
                className="text-sm hover:!bg-[#387464] text-white font-light px-10 py-5 rounded-md"
                onClick={handleReplyClick}
              >
                Reply
              </Button>
            </div>
            <SupportReplyDialog
              onOpen={openReplyDialog}
              onClose={() =>{ setOpenReplyDialog(false);
                fetchData(ticketId);
              }}
              ticketId={ticketId}
              onSubmit={handleReplySuccess}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SupportAction;
